// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__e7m4C","main-image":"Header_main-image__2p1l3"};